import i18n from "@/locales";

export enum TextImageModeEnum {
  Mixed = 1, // 混合模式
  SinglePerson = 2, // 单人图
  MultiplePersons = 3, // 多人图
  NoPerson = 4, // 无人图
  Redraw = 5, // 转绘
  ReplaceCharacter = 6, // 更换人物
  PresetFeature = 7, // 预设特征
  TextGenerateFeature = 8, // 文生特征
  ImageGenerateFeature = 9, // 图生特征
  Beautify = 11, // 美颜
}

export enum ModelVersion {
  V0 = 0,
  V1 = 1,
  V2 = 2,
}

export enum RatioEnum {
  Portrait = "3:4",
  Landscape = "16:9",
}

export const useTextImageModeText = (mode: TextImageModeEnum) => {
  switch (mode) {
    case TextImageModeEnum.Mixed:
      return i18n.global.t("painting.paintType.mix.name");
    case TextImageModeEnum.SinglePerson:
      return i18n.global.t("painting.paintType.text.single");
    case TextImageModeEnum.MultiplePersons:
      return i18n.global.t("painting.paintType.text.multi");
    case TextImageModeEnum.NoPerson:
      return i18n.global.t("painting.paintType.text.nobody");
    case TextImageModeEnum.Redraw:
      return i18n.global.t("painting.paintType.img.repaint");
    case TextImageModeEnum.ReplaceCharacter:
      return i18n.global.t("painting.paintType.img.replace");
    case TextImageModeEnum.PresetFeature:
      return i18n.global.t("painting.traitType.preset.titleSimple");
    case TextImageModeEnum.TextGenerateFeature:
      return i18n.global.t("painting.traitType.text.title");
    case TextImageModeEnum.ImageGenerateFeature:
      return i18n.global.t("painting.traitType.img.title");
    default:
      return "";
  }
};
